<template lang="html">

  <el-select class="inpText" clearable="clearable" size="medium" @change="selectChange" v-model="id" :placeholder="plaText">
      <el-option
        v-for="item in selectArr"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
  </el-select>

</template>

<script>
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    model: {
        prop: "selectId", // 父组件设置v-model的变量值，v-model="message"
        event: "selectChange" // 父组件监听message事件
    },
    name:'dicSelect',
    props:['code','selectId','paramsKey','plaText','mapKey','clearable'],
    watch:{
         selectId:function(e){
             this.id = e;
         }
    },
    data(){
        return{
            id:'',
            selectArr:[],
            dectMap:{}
        }
    },
    methods:{
        selectChange:function(e){
          this.$emit('selectChange',e)
          this.$emit('change',{
              id:e,
              name:this.dectMap[this.id],
              paramsKey:this.paramsKey
          })
        }
    },
    created:function(){
        var vues = this;
        this.id = this.selectId;
        dicSeek({code:this.code}).then(res => {
            var unFormate = res.dataDictionarys;
            vues.selectArr = unFormate;
            for(var i = 0;i < unFormate.length;i++){
                vues.dectMap[unFormate[i].id] = unFormate[i].name;
            }
            vues.$emit('getMap',{
                map:vues.dectMap,
                mapKey:vues.mapKey
            })
        })
    }

}
</script>

<style lang="css" scoped>



</style>



// WEBPACK FOOTER //
// dcSelect.vue?1f240830